<div
  class="menu-overlay"
  *ngIf="menuService.isMenuOpen$ | async"
  (click)="closeMenu()"
>
  <div class="contacts_menu" (click)="$event.stopPropagation()">
    <button class="close_button" (click)="closeMenu()">
      <img
        src="/assets/Contacts_menu/cross1.svg"
        alt="крестик закрыть"
        loading="lazy"
      />
    </button>
    <div class="menu_box">
      <div class="menu">
        <p>Свяжитесь с нами</p>
        <a href="tel:+7 (917) 464 55-32" class="menu_button phone">
          <img
            src="/assets/Contacts_menu/phone.svg"
            alt="телефон"
            loading="lazy"
          />Связаться по телефону
        </a>
        <a
          href="https://t.me/DemlerIT"
          class="menu_button Telegram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assets/Contacts_menu/telegram.svg"
            alt="телеграм"
            loading="lazy"
          />Написать в Telegram
        </a>
        <a class="menu_button form" (click)="goToContacts()">
          <img
            src="/assets/Contacts_menu/form1.svg"
            alt="форма"
            class="form"
            loading="lazy"
          />
          Заполнить форму
        </a>
      </div>
    </div>
  </div>
</div>
